import { render, staticRenderFns } from "./EmbeddedClientDetail.vue?vue&type=template&id=cbb25f2c&scoped=true"
import script from "./EmbeddedClientDetail.vue?vue&type=script&lang=js"
export * from "./EmbeddedClientDetail.vue?vue&type=script&lang=js"
import style0 from "./EmbeddedClientDetail.vue?vue&type=style&index=0&id=cbb25f2c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbb25f2c",
  null
  
)

export default component.exports
import {QBtn} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn})
